import { Button } from "../../../../../../shared";
import { Alert, Box, Typography } from "@mui/joy";
import { Cog, Info } from "lucide-react";

export default function Settings() {
    return (
        <Box>
            <Box>
                <Alert
                    variant="soft"
                    color="warning"
                    sx={{ border: "1px solid", borderColor: "divider", mb: 1, mt: 1 }}
                    startDecorator={<Info size={16} color="currentColor" />}
                >
                    Initial project setup is incomplete. Please click "Rerun Initial Setup" to configure measurements
                    and complete the setup process.
                </Alert>
                <Typography gutterBottom level="title-sm" sx={{ mt: 2 }}>
                    Project setup (30%)
                </Typography>

                <Button size="sm" variant="soft" color="primary" startDecorator={<Cog size={16} />}>
                    Run initial setup
                </Button>
            </Box>
        </Box>
    );
}
